<div class="ajax-loading"><div class="loading-icon"></div></div>
<section class="container-fluid">
    <section class="page-title">
        <h1>User Roles - {{user.username}}</h1>
    </section>
    <mat-card class="card-white">
        <mat-card-content>
            <div class="row example-container">
                <div *ngIf="roleList != null && roleList.length > 0" class="accordion-table-container">
                    <table class="list-table" mat-table [dataSource]="roleList">
                        <ng-container matColumnDef="isChecked">
                            <th mat-header-cell *matHeaderCellDef> </th>
                            <td mat-cell *matCellDef="let element"> 
                                <mat-checkbox [(ngModel)]="element.isChecked"></mat-checkbox>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>Role </th>
                            <td mat-cell *matCellDef="let element"> 
                                <span>{{element.name}}</span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="description">
                            <th mat-header-cell *matHeaderCellDef>Description </th>
                            <td mat-cell *matCellDef="let element"> 
                                <span>{{element.description}}</span>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
                <div *ngIf="roleList == null || roleList.length <= 0" class="no-record-found">No record found.</div>
            </div>
            <div class="col-sm-12">
                <div class="text-center mt-3 d-flex">
                        <button mat-raised-button color="primary" type="button" (click)="saveUserRole()" class="oms-btn me-3">Save </button>&nbsp;&nbsp;
                    <a mat-raised-button color="primary" routerLink="/users" class="oms-btn-primary m-l-10">Cancel</a>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
  </section>
    